const getAppFrameName = (targetId, frameIndex) => {
  return `csframe_${targetId}_${frameIndex}`;
};

export default getAppFrameName;
